/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PdgmGroupingEstimateViewModel } from './PdgmGroupingEstimateViewModel'; 

export function getPdgmGroupingEstimateOptions(oasisAssessmentId: string, timingId: number, admissionSourceId: number, onSuccess?: (result: PdgmGroupingEstimateViewModel) => void) {
	return queryOptions({
		queryKey: ['pdgm-grouping-estimate', oasisAssessmentId, timingId, admissionSourceId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getpdgmgroupingestimate/' + oasisAssessmentId + '/' + timingId + '/' + admissionSourceId;
			const resp = await axios.get<PdgmGroupingEstimateViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(oasisAssessmentId) && Boolean(timingId) && Boolean(admissionSourceId)
	});
}